import { CheckCircle } from "lucide-react";
import HeroLeadForm from "@/components/HeroLeadForm";
import heroImage from "@/assets/hero-construction.jpg";

const benefits = [
  "Instalação rápida em até 30 minutos",
  "Economia de até 40% na mão de obra",
  "Produto com garantia e qualidade",
];

const Hero = () => {
  return (
    <section className="relative w-full overflow-hidden bg-black">
      <img
        src={heroImage}
        alt="Obra com kit porta pronta Solari"
        className="absolute inset-0 h-full w-full object-cover"
        width={1920}
        height={1080}
        loading="eager"
        fetchPriority="high"
        decoding="async"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-black/85 via-black/70 to-black/50" />

      <div className="container-custom relative z-10 grid items-center gap-8 py-10 md:py-16 lg:grid-cols-[1.1fr_1fr] lg:gap-12">
        {/* Coluna esquerda: copy */}
        <div className="order-2 lg:order-1">
          <span className="mb-4 inline-block rounded-full bg-primary/90 px-4 py-1.5 font-heading text-xs font-semibold uppercase tracking-wider text-primary-foreground">
            Atendemos Goiânia e Região
          </span>
          <h1 className="mb-5 font-heading text-3xl font-extrabold leading-tight text-primary-foreground md:text-4xl lg:text-5xl">
            Cansado de atrasos na obra e custos altos com portas?
          </h1>
          <p className="mb-6 text-base leading-relaxed text-gray-200 md:text-lg">
            Com o <strong className="text-primary-foreground">Kit Porta Pronta Solari</strong>, você instala em minutos,
            economiza na mão de obra e mantém seu cronograma em dia.
          </p>

          <ul className="space-y-2.5">
            {benefits.map((b, i) => (
              <li key={i} className="flex items-center gap-3 text-gray-200">
                <CheckCircle className="h-5 w-5 flex-shrink-0 text-green-400" />
                <span>{b}</span>
              </li>
            ))}
          </ul>
        </div>

        {/* Coluna direita: formulário */}
        <div className="order-1 lg:order-2">
          <HeroLeadForm />
        </div>
      </div>
    </section>
  );
};

export default Hero;
